<template>
  <div>
    <button
      type="button"
      class="btn btn-with-addon"
      style="background-color: #107c41; color: #fff;"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Bulk Update
    </button>

    <a-modal v-model="visible" title="Bulk Update Students" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Update</a-button>
      </template>

      <a-form :form="form">
        <div class="row">
          <div class="col-md-4 mb-2">
            <a-form-item
              label="Session"
            >
              <a-select
                v-decorator="[
                  'session_id',
                  {rules: [{ required: true, message: 'Please select a session!!' }], initialValue: currentSession ? currentSession.id : ''}
                ]"
                placeholder="Select session"
                @change="handleSessionChange"
              >
                <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-3">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <p class="mt-3 mb-0">Download the CSV file format here.
          <a
            href="/resources/csv/neoskool_student_bulk_import_update.csv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Download CSV
          </a>
          <span class="font-weight-bold text-warning">Fields marked with * are required!</span>
        </p>
        <div class="row">
          <div class="col-md-4">
            <a-form-item
              label="CSV File"
            >
              <a-upload
                v-decorator="['file', {rules: [{ required: true, message: 'Please select a csv file to upload!' }]}]"
                accept=".csv, application/vnd.ms-excel, text/csv"
                :fileList="fileList"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="!uploadDisabled">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

export default {
  name: 'BulkUpdateStudent',
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      schoolSessions: [],
      selectedSession: undefined,
    }
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload (file) {
      const isCSV = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.form.resetFields(['class_id', 'section_id'])

      this.getClasses()
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to bulk upload students!`,
            onOk: () => {
              let formData = window.jsonToFormData(values, options)

              const csvFile = values.file.file
              formData.append('file', csvFile)

              this.$http
                .post('/api/student/import/update', formData)
                .then(({ data }) => {
                  this.$emit('created')
                  this.$eventBus.$emit('calendarEventUpdated')
                  this.loading = false
                  this.visible = false
                  this.$notification['info']({
                    message: 'Bulk update started!',
                    description: `Bulk student update has started! You will be notified once it is completed!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
